module.exports = __webpack_public_path__ + "img/bg-supplier.4140f391.jpeg";